import React from 'react';
import { DeliveryProvider } from '../../types/constants';
import UberEatsIcon from './UberEatsIcon';
import WoltIcon from './WoltIcon';
import { IconProps } from './types';

type Props = IconProps & {
  provider: DeliveryProvider;
};

export default function DeliveryProviderIcon({ provider, ...props }: Props) {
  return (
    {
      [DeliveryProvider.FirstDelivery]: <UberEatsIcon {...props} />,
      [DeliveryProvider.UberDrive]: <UberEatsIcon {...props} />,
      [DeliveryProvider.WoltDrive]: <WoltIcon {...props} />,
    }[provider] ?? null
  );
}
